import { useFormikContext } from 'formik'
import { useCallback } from 'react'
import { ImportUtilityModel } from '../../typings'

export function useHandlers(onClose: () => void) {
  const { submitForm, isSubmitting, errors } =
    useFormikContext<ImportUtilityModel>()
  const handleSave = useCallback(() => {
    submitForm()
    if (errors) {
      if (errors['salesTeamId'] || errors['salesFunnelId']) onClose()
    }
  }, [errors, onClose, submitForm])

  return {
    handleSave,
    isSubmitting,
  }
}
